import { BASE_URL_PROD } from "./const";
import { AUTH_TOKEN } from "./const";
import { deleteCookie, getCookie, setCookie } from "cookies-next";

export const tokenUtils = {
  save: (info: string) => {
    setCookie(AUTH_TOKEN, info);
  },

  get: () => {
    return getCookie(AUTH_TOKEN);
  },

  delete: () => {
    deleteCookie(AUTH_TOKEN);
  },
};

export const domain = () => {
  const env = process.env.REACT_APP_ENV;
  let domain = "";
  if (env === "pro") {
    domain = BASE_URL_PROD
  } else {
    domain = BASE_URL_PROD // `https://sensejupiter${`-${env}`}.sensetime.com`;
  }
  return domain;
};
